import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { articuloPorId } from '../../data/ayuda/articulos';

export default function ArticulosRelacionados({ relacionados = [] }) {
  const navigate = useNavigate();
  const items = relacionados.map(id => articuloPorId(id)).filter(Boolean);

  if (!items.length) return null;

  return (
    <Box sx={{ mt: 5, pt: 3, borderTop: '1px solid rgba(255,255,255,0.08)' }}>
      <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#546e7a', textTransform: 'uppercase', letterSpacing: '0.12em', mb: 1.5 }}>
        También puede interesarte
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        {items.map(a => (
          <Box
            key={a.id}
            onClick={() => navigate(`/manual/${a.id}`)}
            sx={{
              display: 'flex', alignItems: 'center', gap: 1.5,
              p: '10px 12px', borderRadius: 1.5,
              border: '1px solid rgba(255,255,255,0.06)',
              bgcolor: 'rgba(255,255,255,0.02)',
              cursor: 'pointer',
              '&:hover': { bgcolor: 'rgba(144,202,249,0.06)', borderColor: 'rgba(144,202,249,0.2)' },
              transition: 'all 0.15s',
            }}
          >
            <Typography sx={{ fontSize: 15, color: '#3d6a8a', flexShrink: 0 }}>📄</Typography>
            <Box>
              <Typography sx={{ fontSize: 14, color: 'var(--c-acento)', fontWeight: 500 }}>
                {a.titulo}
              </Typography>
              <Typography sx={{ fontSize: 12, color: '#546e7a', mt: 0.25 }}>
                {a.resumen}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
